import { useContext, useEffect, useRef, useState } from "react";
import { Button, CardFooter, Modal } from "react-bootstrap";
import "react-circular-progressbar/dist/styles.css";
import { useLocation, useNavigate } from "react-router-dom";

import { Country } from "country-state-city";
import filtering from "../../../Assets/images/filter.svg";
import NotificationModal from "../../../Components/NotificationModal/NotificationModal";
import ActionButtons from "../../../Components/SearchHeader/ActionButton";
import FilterModal from "../../../Components/SearchHeader/FilterModal";
import SearchField from "../../../Components/SearchHeader/SearchField";
import SortFilterControls from "../../../Components/SearchHeader/SortFilterControls";
import CourseCard from "../../../Components/courseCard/courseCard";
import { AppProvider } from "../../../ContextApi/AppContext";
import Footer from "../../../Pages/MainLayout/Footer/Footer";
import MobileFooter from "../../../Pages/MainLayout/Footer/MobileFooter";
import Headings from "../../../Pages/MainLayout/Headings/Headings";
import Line from "../../../Pages/MainLayout/Line/Line";
import ImagePath from "../../../constants/ImagePath";
import { API_URL } from "../../../server";
import WalletModal from "../../MainLayout/Headings/WalletModal";
import "./CardCourses.css";

const CardCourses = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(AppProvider);
  const buttonRef = useRef(null);

  const selectedSubject = location?.state?.selectedSubject || null;
  const [cardDetails, setCardDetails] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [colorIndex, setColorIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [filterType, SetfilterType] = useState("subject"); // default view
  const [selectedSubCategory, setSelectedSubCategory] =
    useState("Add a Filter");
  const [countries, setCountries] = useState([]);
  const [searchCountry, setSearchCountry] = useState(""); // 💡 Parent state

  const [selectedCategory, setselectedCategory] = useState();
  const [sort, setSort] = useState(false);
  const [filter, setFilter] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeIndex, setActiveIndex] = useState("all");
  const [sortCriteria, setSortCriteria] = useState("Featured");
  const [enquiryModal, setEnquiryModal] = useState(false); // Modal 1
  const [notificationModal, setNotificationModal] = useState(false);
  const [data, setdata] = useState(0);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [groupedCategories, setGroupedCategories] = useState({});
  const [sessionTypeName, setSessionTypeName] = useState("");

 const registerid = sessionStorage.getItem('registerid')

  const token = sessionStorage.getItem("token");

  // const greenCourses =
  // JSON.parse(localStorage.getItem("greenCourses") || "[]");

  

// const greenCourses = registerid
//   ? JSON.parse(
//       localStorage.getItem(`greenCourses_${registerid}`) || "[]"
//     )
//   : [];

const isCourseCompleted = (course) => {
  if (!course) return false;

  const completed = Number(course.completedAnswers);
  const total = Number(course.totalAnswers);

  if (isNaN(completed) || isNaN(total)) return false;

  return total > 0 && completed === total;
};



  useEffect(() => {
    getCardDetails();
  }, []);

  // 👇 Add this right after getCardDetails effect
  useEffect(() => {
    if (selectedSubject && cardDetails.length > 0) {
      const filtered = cardDetails.filter((course) =>
        course.mySubject?.some((sub) =>
          sub.toLowerCase().includes(selectedSubject.toLowerCase())
        )
      );
      setCardDetails(filtered);
    }
  }, [selectedSubject, cardDetails]);

  useEffect(() => {
    const countryList = Country.getAllCountries();
    setCountries(countryList);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 750); // Bootstrap's lg breakpoint (≤ 992px)
    };

    handleResize(); // Check on load
    window.addEventListener("resize", handleResize); // Listen for resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);

  const getCardDetails = () => {
    const registerid = sessionStorage.getItem("registerid");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);
    const raw = JSON.stringify({
      user_id: registerid,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getAllCourse", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status == true) {
          console.log("getAllCourse", result);
          setCardDetails(result.data.courses);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const gotocoursesoutline = (
    subjectname,
    courseName,
    subid,
    coursename,
    accept_badge_url,
    duration,
    courseDescription,
    courseOneLiner,
    courseSession
  ) => {
    navigate("/CourseOutline", {
      state: {
        subjectname: subjectname,
        courseName: courseName,
        subid: subid,
        coursename: coursename,
        acceptbadgeurl: accept_badge_url,
        duration: duration,
        courseDescription: courseDescription,
        courseOneLiner: courseOneLiner,
        courseSession: courseSession,
      },
    });
  };

  const convertMinutesToHours = (minutes) => {
    if (!minutes || minutes <= 0) return "0 min"; // Handle edge cases

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours > 0 && mins > 0) {
      return `${hours} hour ${mins} min course`;
    } else if (hours > 0) {
      return `${hours} hour course`;
    } else {
      return `${mins} min course`;
    }
  };

  const roundRatio = (completionRatio) => {
    console.log("completionRatio", completionRatio);
    if (!completionRatio || !completionRatio.includes("/")) return 0; // Handle invalid cases
    const [completed, total] = completionRatio.split("/").map(Number);
    return total > 0 ? (completed / total) * 100 : 0; // Avoid division by zero
  };

  const getButtonText = (completionRatio) => {
    const percentage = roundRatio(completionRatio);
    if (percentage === 0) return "Start now"; // Not started
    if (percentage > 0 && percentage < 100) return "Continue"; // In progress
    if (percentage === 100) return "Review"; // Completed

    return "Start now"; // Default case
  };
  
//   const getButtonText = (completionRatio) => {
//   return "Start now";
// };


  const getexpertsbysubject = (subject) => {
    const safeSubject = Array.isArray(subject) ? subject[0] : subject;
    navigate("/Flowsubjectdetails", { state: { subject: safeSubject } });
  };

  const colorList = [
    "bg-figma1",
    "bg-figma2",
    "bg-figma3",
    "bg-figma4",
    "bg-figma5",
    "bg-figma6",
    "bg-figma7",
    "bg-figma8",
    "bg-figma9",
    "bg-figma10",
  ];

  const getColor = (index) =>
    colorList[(colorIndex + index) % colorList.length];

  const sortClose = () => {
    setSort(false);
  };
  const sortShow = () => {
    setFilter(false);
    setSort(true);
  };

  const filterClose = () => {
    setFilter(false);
  };
  const filterShow = () => {
    setSort(false);
    setFilter(true);
  };

  //handleSortChange

  const handleSortChange = (event) => {
    const value = event.target.value;
    let sortedData = [...cardDetails];
    if (value === "nameAsc") {
      sortedData.sort((a, b) => a.courseName.localeCompare(b.courseName));
      setSortCriteria("Name (A-Z)");
    } else if (value === "nameDesc") {
      sortedData.sort((a, b) => b.courseName.localeCompare(a.courseName));
      setSortCriteria("Name (Z-A)");
    } else if (value == "priceLowHigh") {
      sortedData.sort((a, b) => a.amount - b.amount);
    } else if (value == "priceHighLow") {
      sortedData.sort((a, b) => b.amount - a.amount);
    } else {
      setSortCriteria("Featured");
    }

    setCardDetails(sortedData);
    sortClose();
  };

  useEffect(() => {
    const removeDuplicates = (data) => {
      const uniqueSubCategories = [];
      const seen = new Set();

      data.forEach((subCategory) => {
        const uniqueKey = `${subCategory.categoryText}-${subCategory.subject}`;
        if (!seen.has(uniqueKey)) {
          seen.add(uniqueKey);
          uniqueSubCategories.push(subCategory);
        }
      });

      return uniqueSubCategories;
    };

    const groupByCategory = (data) => {
      return data.reduce((acc, subCategory) => {
        const { categoryText } = subCategory;
        if (!acc[categoryText]) {
          acc[categoryText] = [];
        }
        acc[categoryText].push(subCategory);
        return acc;
      }, {});
    };

    const uniqueSubCategories = removeDuplicates(subCategories);
    setGroupedCategories(groupByCategory(uniqueSubCategories));
  }, [subCategories]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      const requestOptions = {
        method: "POST",
        redirect: "follow",
      };

      try {
        const response = await fetch(
          API_URL + "getAllSubCategory",
          requestOptions
        );
        const result = await response.json();
        setSubCategories(result.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSubCategories();
  }, []);


  // const registerid = sessionStorage.getItem("registerid");

  const openNotificationModal = () => {
    if (registerid === null) {
      navigate("/", {
        state: true,
      });
    } else {
      setNotificationModal(true);
    }
  };

  // On component mount: check if returning from session guide
  useEffect(() => {
    if (location.state?.fromSessionGuide) {
      setEnquiryModal(true);
    }
  }, [location.state]);

  // Modal open handler (Course Click)
  const openSupportModal = () => {
    if (registerid === null) {
      // navigate('/', {
      //     state: true
      // })
      setEnquiryModal(true);
    } else {
      setEnquiryModal(true);
    }
  };

  // Modal 1 Close
  const openSupportClose = () => {
    setEnquiryModal(false);
  };

  const closeNotificationModal = () => {
    getnotificationCount();
    setNotificationModal(false);
  };

  const handleNavigateToWallet = () => {
    const registerid = sessionStorage.getItem("registerid");
    if (registerid === null) {
      navigate("/", {
        state: true,
      });
    } else {
      // navigate('/SettingsMainScreen/SettingWallet', { state: 6 });
      setShowWalletModal(true);
    }
  };

  const getnotificationCount = async () => {
    const registerid = sessionStorage.getItem("registerid");
    const token = sessionStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      user_id: registerid,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getNotificationCount", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status == true) {
          setdata(result.count);
        }
      })
      .catch((error) => console.error(error));
  };

  //  getcategories();
  useEffect(() => {
    getcategories();
  }, []);

  const handleClicks = (index, category) => {
    setActiveIndex(index);
    setselectedCategory(category);
  };

  const callbynameCategory = (category) => {
    console.log("categoryyyyyyyyyyy" + category);
    if (registerid === null) {
      navigate("/", {
        state: true,
      });
    } else {
      getbynameCategory(category);
    }
  };

  const getbynameCategory = (category) => {
    console.log("categorycategory" + category);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      categoryText: category,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    console.log("requestOptions", requestOptions);

    fetch(API_URL + "getCategoryFilter", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status == true) {
          if (
            result.message ==
            "No subcategories found for the provided categoryText."
          ) {
            setCardDetails([]);
          } else {
            console.log("getCategoryFilter", result);
            // const sessiontocategoryfilter = result.data.filter(stc => stc.preferredSessionType.includes(sessionTypeName));
            setCardDetails(result.data);
          }
        } else {
          setCardDetails([]);
        }
      })
      .catch((error) => console.error(error));
  };

  const getcategories = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(API_URL + "getAllCategory", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("getAllCategory", result.data);
        setCategories(result.data);
      })
      .catch((error) => console.error(error));
  };

  const [selectedFilters, setSelectedFilters] = useState({
    subject: "",
    location: "",
    type: "",
  });

  //filter logic
  const filteredCardDetails = cardDetails?.filter((details) => {
    const searchLower = searchQuery.toLowerCase();

    // ✅ Search matches (name or subject)
    const nameMatch = details.courseName?.toLowerCase().includes(searchLower);
    const subjectMatch = details.mySubject?.some((subject) =>
      subject.toLowerCase().includes(searchLower)
    );

    // ✅ Subcategory filter (from dropdown)
    const subcategoryMatch =
      !selectedSubCategory ||
      selectedSubCategory === "Add a Filter" ||
      details.mySubject?.some(
        (subject) =>
          subject.toLowerCase().trim() ===
          selectedSubCategory.toLowerCase().trim()
      );

    // ✅ Category filter (main category button)
    const matchedSubjects = subCategories
      ?.filter((sub) => sub.categoryText === selectedCategory)
      ?.map((sub) => sub.subject?.toLowerCase());

    const categoryMatch =
      !selectedCategory || selectedCategory === "all"
        ? true
        : details.mySubject?.some((subject) =>
            matchedSubjects.includes(subject.toLowerCase())
          );

    // ✅ Final return condition
    return (nameMatch || subjectMatch) && categoryMatch && subcategoryMatch;
  });

  const navigateTo = () => navigate("/SettingContentSupport");

  const isPhone = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Choose correct link
  const supportLink = isPhone
    ? "mailto:hello@recess.education" // mobile
    : "https://mail.google.com/mail/?view=cm&fs=1&to=hello@recess.education";

  return (
    <div className="min-h-screen bg-[#F5F3EE] flex flex-col w-m-xxl-auto">
      <div className="w-full ">
        <NotificationModal
          show={notificationModal}
          handleClose={closeNotificationModal}
        />
        <Headings screenHeadingName="courses." />
        {/* <Line />
        <p className="cpara m-3" >
          Join professional courses, gain valuable in-demand skills, and earn a verified certificate when you finish.
        </p>
        <Line /> */}

        <main className="flex-1 mx-auto py-2 px-4 min-[600px]:px-2">
          <div className="flex flex-col md:flex-row md:items-center md:justify-start gap-1  w-full">
            <div className="flex flex-col md:flex-row md:items-center gap-3 flex-1 mb-2">
              {/* Search Field */}
              <SearchField
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
              />

              {/* place at one row    */}
              <div className="flex gap-1 justify-between">
                <SortFilterControls
                  sortShow={sortShow}
                  sortCriteria={sortCriteria}
                  filterShow={filterShow}
                  selectedSubCategory={selectedSubCategory}
                  ImagePath={ImagePath}
                  filtering={filtering}
                />
                {/* place at end Right Side  Action Buttons */}
                <div className="block md:hidden flex items-center justify-between gap-2 mt-2">
                  <ActionButtons
                    onSupportClick={openSupportModal}
                    onNotificationClick={openNotificationModal}
                    onWalletClick={handleNavigateToWallet}
                    notificationCount={data}
                    ImagePath={ImagePath}
                  />
                </div>
              </div>
            </div>
            {/* place at end Right Side this one show  for  tab and desktop responsive */}
            <div className="hidden md:flex items-center justify-end gap-2">
              <ActionButtons
                onSupportClick={openSupportModal}
                onNotificationClick={openNotificationModal}
                onWalletClick={handleNavigateToWallet}
                notificationCount={data}
                ImagePath={ImagePath}
              />
            </div>
          </div>

          <div className="w-full">
            {" "}
            <Line />
          </div>

          {/* Subject Filters */}
          <div className="overflow-x-auto scrollbar-hide mt-3">
            <div className="flex whitespace-nowrap gap-3 mb-8 w-max px-1 ">
              <Button
                ref={buttonRef}
                className={`subjectbutton flex items-center justify-center gap-2 
    px-3 py-2 rounded-md text-sm font-medium text-black
    ${getColor(9)} ${selectedSubCategory === "all" ? "active" : ""} `}
                value="All"
                onClick={() => {
                  setActiveIndex("all");
                  setselectedCategory("");
                  getCardDetails();
                }}
              >
                {activeIndex === "all" && (
                  <img
                    className="d-inline g-2"
                    src={ImagePath.alltick}
                    alt="tick"
                  />
                )}{" "}
                All Subjects
              </Button>

              {categories.map((subject, index) => (
                <Button
                  key={index}
                  variant="outline-dark"
                  className={`subjectbutton flex items-center justify-center gap-1 
        px-4 py-2 rounded-md text-sm font-medium 
        ${getColor(index)} ${selectedSubCategory === subject ? "ring-2" : ""}`}
                  value={subject.categoryText}
                  onClick={() => handleClicks(index, subject.categoryText)}
                >
                  {activeIndex === index && (
                    <img
                      className="d-inline g-2"
                      src={ImagePath.alltick}
                      alt="tick"
                    />
                  )}
                  {subject.categoryText}
                </Button>
              ))}
            </div>
          </div>

          {filteredCardDetails && filteredCardDetails.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
              {filteredCardDetails.map((details, index) => (
                <CourseCard
                  key={index}
                  details={details}
                  // isGreen={greenCourses.includes(details._id)}
                   isGreen={isCourseCompleted(details)}
                  forwordicon={ImagePath.forwordicon}
                  award={ImagePath.award}
                  getButtonText={getButtonText}
                  roundRatio={roundRatio}
                  convertMinutesToHours={convertMinutesToHours}
                  getexpertsbysubject={getexpertsbysubject}
                  gotocoursesoutline={gotocoursesoutline}
                  setState={setState}
                />
              ))}
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "45vh" }}
            >
              <div className="text-center">
                <h5 className="mt-3 card-title-favorite">No Courses Found</h5>
                <p className="mb-1 text-sm">We're adding more courses soon.</p>
                <p className="mb-0 text-sm">Check back later.</p>
              </div>
            </div>
          )}
        </main>

        {/* {/ sorted started /} */}
        <Modal
          show={sort}
          onHide={sortClose}
          centered
          className="items-center m-0"
        >
          <div className="modalbackgroundcolor p-4 rounded-3">
            <div className="xmark">
              <button
                type="button"
                className="btn btn-close ms-auto"
                onClick={sortClose}
              ></button>
            </div>
            <dl style={{ marginTop: "50px", marginLeft: "30px" }}>
              <dt className="sortHeading">Sort by</dt>
              <hr className="lines mb-4" />
              <dd className="sortnames">
                <input
                  type="radio"
                  id="featured"
                  name="sort"
                  value="featured"
                  className="color-block"
                  checked={sortCriteria === "Featured"}
                  onChange={handleSortChange}
                />
                <label htmlFor="featured" className="mb-3">
                  Featured
                </label>
              </dd>
              <hr className="lines mb-3" />
              <dd className="sortnames">
                <input
                  type="radio"
                  id="nameAsc"
                  name="sort"
                  value="nameAsc"
                  className="color-block"
                  checked={sortCriteria === "Name (A-Z)"}
                  onChange={handleSortChange}
                />
                <label htmlFor="nameAsc" className="mb-3">
                  Name (A-Z)
                </label>
              </dd>
              <hr className="lines mb-3" />
              <dd className="sortnames">
                <input
                  type="radio"
                  id="nameDesc"
                  name="sort"
                  value="nameDesc"
                  className="color-block"
                  checked={sortCriteria === "Name (Z-A)"}
                  onChange={handleSortChange}
                />
                <label htmlFor="nameDesc" className="mb-3">
                  Name (Z-A)
                </label>
              </dd>

              <hr className="lines mb-5" />
            </dl>
          </div>
        </Modal>

        <WalletModal
          stripmodal={showWalletModal}
          closestripModal={() => setShowWalletModal(false)}
          price={100}
          currency="USD"
        />

        <FilterModal
          filter={filter}
          filterClose={filterClose}
          filterType={filterType}
          SetfilterType={SetfilterType}
          groupedCategories={groupedCategories}
          countries={countries}
          selectedSubCategory={selectedSubCategory}
          setSelectedSubCategory={setSelectedSubCategory}
          getCardDetails={getCardDetails}
          searchCountry={searchCountry}
          setSearchCountry={setSearchCountry}
          visibleFilters={["subject"]}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />

        {/* Step 1:enquiryModal Modal 1 */}
        <Modal
          centered
          show={enquiryModal}
          onHide={openSupportClose}
          className="items-center m-0"
        >
          <div className="overflow-hidden rounded-lg">
            <div className="relative w-full">
              <img
                src={ImagePath.getQualified}
                alt="query_image1"
                className="w-full  px-0 py-0 object-cover"
              />

              <div className="absolute top-3 right-3">
                <button
                  type="button"
                  className="btn btn-close color-white bg-white"
                  onClick={openSupportClose}
                ></button>
              </div>
            </div>

            <div className="modalbackgroundcolor p-4 d-flex flex-column justify-content-center align-items-center text-center">
              <dt className="sortHeading">Get Qualified.</dt>
              <p className="text-gray mb-3 mt-2 fw-medium">
                Enrol in professionally designed courses, build in-demand skills
                with guided resources, and earn a verified certificate on
                completion.
              </p>

              <button
                onClick={() => {
                  openSupportClose();
                }}
                className="w-100 bg-dark text-white rounded-md fw-medium hover:bg-secondary transition py-2"
              >
                Browse Courses
              </button>

              <div className="text-center mt-4">
                <p className="text-gray fw-medium mb-0">
                  Need help? You can always{" "}
                  {/* <a
                    href='https://mail.google.com/mail/?view=cm&fs=1&to=hello@recess.education'
                    target='_blank'
                    rel='noopener noreferrer'
                     className="fw-medium text-neutral-900 underline hover:text-gray-500 transition-colors duration-200"
                  >
                    Contact Support
                  </a> */}
                  <a
                    href={supportLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fw-medium text-neutral-900 underline hover:text-gray-500 transition-colors duration-200"
                  >
                    Contact Support.
                  </a>
                  {/* <span
                    className='fw-medium text-muted'
                    style={{ textDecoration: 'none' }}
                  >
                    {' '}
                    for further help
                  </span> */}
                </p>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <CardFooter className="mt-auto">
        <p></p>
        <Line />
        <div>
          {/* <Footer /> */}
          {isMobile ? <MobileFooter /> : <Footer />}
        </div>
      </CardFooter>
    </div>
  );
};

export default CardCourses;
